import BaseFeature from '../../foundation/base/base';

export default class Image extends BaseFeature {
	constructor(element) {
		super(element);

		this.elm = element;
		this.initDomCache();
		this.init();
	}

	init() {
		const supportObjectFit = 'objectFit' in document.documentElement.style;
		const imageCover = this.elm.classList.contains('a-image--cover');
		if (!supportObjectFit && imageCover) {
			this.objectFit();
		}
	}

	objectFit() {
		const imgUrl = this.elm.dataset.fallbackUrl;
		this.elm.style.backgroundImage = `url(${imgUrl})`;
		this.elm.classList.add('a-image--cover-fallback');
		this.elm.innerHTML = '';
	}
}
